import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AjudaRoutingModule } from './ajuda-routing.module';
import { ListaFaqComponent } from './lista-faq/lista-faq.component';
import { VisualizarFaqComponent } from './visualizar-faq/visualizar-faq.component';
import {FormsModule} from "@angular/forms";
import {ComponentesModule} from "../../core/componentes/componentes.module";


@NgModule({
  declarations: [
    ListaFaqComponent,
    VisualizarFaqComponent
  ],
  imports: [
    CommonModule,
    AjudaRoutingModule,
    FormsModule,
    ComponentesModule
  ]
})
export class AjudaModule { }
